import { sprite, type SpriteDef } from './types';

// Symbol sprites: 32×32, 1-px ink outline, readable by silhouette alone.
// Key: '.' transparent, 'o' ink outline, others per sprite.

export const cherry = sprite(
  'sym_cherry',
  { o: 'ink', r: 'red', d: 'blood', h: 'coral', w: 'white', g: 'clover', G: 'forest', s: 'mud' },
  [
    '................................',
    '................................',
    '..................ooo...........',
    '.................oGGGo..........',
    '................oGggGGoo........',
    '...............oGggggGGGo.......',
    '...............oGgggGGGo........',
    '..............ooGGGGoo..........',
    '.............osoooooo...........',
    '............osso.os.............',
    '...........osso..os.............',
    '..........osso...oso............',
    '.........osso.....os............',
    '........osso......oso...........',
    '.......oooo........os...........',
    '.....oorrrroo......oso..........',
    '....orrrrrrrro...oooooo.........',
    '...orrwhrrrrrdo.oorrrrroo.......',
    '...orwhhrrrrrdooorrrrrrrro......',
    '..orrhhrrrrrrrdoorwhrrrrrdo.....',
    '..orrrrrrrrrrrdorwhhrrrrrrdo....',
    '..orrrrrrrrrrrdorrhhrrrrrrdo....',
    '..orrrrrrrrrrddorrrrrrrrrrdo....',
    '..odrrrrrrrrrddorrrrrrrrrrdo....',
    '...odrrrrrrrdddorrrrrrrrrddo....',
    '...oddrrrrrddd.odrrrrrrrrddo....',
    '....odddddddo...oddrrrrrddo.....',
    '.....ooooooo.....odddddddo......',
    '..................ooooooo.......',
    '................................',
    '................................',
    '................................',
  ],
);

export const lemon = sprite(
  'sym_lemon',
  { o: 'ink', y: 'lemon', Y: 'lime', d: 'moss', w: 'white', g: 'clover', G: 'forest' },
  [
    '................................',
    '................................',
    '................................',
    '...................ooo..........',
    '..................oGgGo.........',
    '.................oGggGo.........',
    '...............ooGGGoo..........',
    '.............ooyyooo............',
    '..........oooyyyyyyooo..........',
    '........ooyyyyyyyyyyyyoo........',
    '.......oyyywwyyyyyyyyyYYo.......',
    '......oyyywwyyyyyyyyyyyYYo......',
    '.....oyyywwyyyyyyyyyyyyyYYo.....',
    '....oyyyywyyyyyyyyyyyyyyyYYo....',
    '....oyyyyyyyyyyyyyyyyyyyyYYo....',
    '...oyyyyyyyyyyyyyyyyyyyyyYYdo...',
    '...oyyyyyyyyyyyyyyyyyyyyyYYdo...',
    '...oyyyyyyyyyyyyyyyyyyyyYYYdo...',
    '...oYyyyyyyyyyyyyyyyyyyyYYddo...',
    '....oYyyyyyyyyyyyyyyyyyYYYdo....',
    '....oYYyyyyyyyyyyyyyyyYYYddo....',
    '.....oYYyyyyyyyyyyyyYYYYddo.....',
    '......oYYYyyyyyyyyYYYYYddo......',
    '.......odYYYYYYYYYYYYdddo.......',
    '........oddYYYYYYYYdddoo........',
    '.........oodddddddddoo..........',
    '..........ooooddoooo............',
    '..............oo................',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const seven = sprite(
  'sym_seven',
  { o: 'ink', r: 'red', d: 'blood', h: 'coral', y: 'gold', b: 'brass' },
  [
    '................................',
    '................................',
    '................................',
    '....oooooooooooooooooooooooo....',
    '...obbbbbbbbbbbbbbbbbbbbbbbbo...',
    '...obhhhhhhhhhhhhhhhhhhhhhhyo...',
    '...obhrrrrrrrrrrrrrrrrrrrrdyo...',
    '...obhrrrrrrrrrrrrrrrrrrrrdyo...',
    '...obhrrddddddddddddrrrrrdyyo...',
    '...obyyyyyyyyyyyyyyorrrrrdyo....',
    '....oooooooooooooooorrrrdyyo....',
    '..................orrrrrdyo.....',
    '.................orrrrrdyyo.....',
    '................orrrrrdyyo......',
    '................orrrrrdyo.......',
    '...............orrrrrdyyo.......',
    '...............orrrrrdyo........',
    '..............orrrrrdyyo........',
    '..............orrrrrdyo.........',
    '.............orrrrrdyyo.........',
    '.............orrrrrdyo..........',
    '............ohrrrrdyyo..........',
    '............ohrrrrdyo...........',
    '............ohrrrrdyo...........',
    '............ohrrrddyo...........',
    '............obddddyyo...........',
    '............obyyyyyyo...........',
    '.............oooooooo...........',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const SYMBOL_SPRITES_A: SpriteDef[] = [cherry, lemon, seven];
